import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=10a57099&scoped=true&lang=pug"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"
import style0 from "./swiper.vue?vue&type=style&index=0&id=10a57099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a57099",
  null
  
)

export default component.exports